module.exports = __webpack_public_path__ + "img/2024-07_we-are-georgia.a307ae1b.png";